var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-de25c3c4-ee6a-4f25-9ad0-a757b3f0c159",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.51 25.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-05ff7aee-90bf-4916-b620-b67ca1866298{fill:url(#uuid-4a8671ab-b580-4163-b882-a5f732a0f46e);}.uuid-869a7c45-a17c-4f65-8e2d-6e6bcdd0fc59{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4a8671ab-b580-4163-b882-a5f732a0f46e",
    x1: 0,
    y1: 12.76,
    x2: 25.51,
    y2: 12.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f21e2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec1d25"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-690d704e-f9cc-4edb-a116-a0afe82a250d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-05ff7aee-90bf-4916-b620-b67ca1866298",
    cx: 12.76,
    cy: 12.76,
    r: 12.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-869a7c45-a17c-4f65-8e2d-6e6bcdd0fc59",
    d: "M7.29,15.94H2.69v-6.24h1.41v5.14h3.19v1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-869a7c45-a17c-4f65-8e2d-6e6bcdd0fc59",
    d: "M9.84,15.94h-1.44v-6.24h1.44v6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-869a7c45-a17c-4f65-8e2d-6e6bcdd0fc59",
    d: "M17.02,9.7l-2.34,6.24h-1.58l-2.37-6.24h1.52l1.47,4.38c.06,.21,.12,.41,.2,.62,.09-.28,.16-.5,.2-.65l1.38-4.35h1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-869a7c45-a17c-4f65-8e2d-6e6bcdd0fc59",
    d: "M22.82,15.94h-4.88v-6.24h4.8v1.16h-3.39v1.36h3.16v1.16h-3.16v1.47h3.47v1.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLive);
export default __webpack_public_path__ + "static/media/banner_live.25b41b14511ff055da68b9b68379979e.svg";
export { ForwardRef as ReactComponent };